// Client application form: website: the routes and the sidebar rows of `wealth.onboarding.application-form.website` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.onboarding.application-form.website',
    routes: [
        // The prospect home. It runs on the APPLICANT cookie
        // and not on a portal session, because no `Client` row
        // exists until the application is submitted, so it sits
        // outside the gated set of the layout route.
        {
            frontend: 'portal',
            path: 'application',
            lazy: () => import('@/pages/portal/application/page'),
        },
        // The public client application (SEP-263). It has no layout
        // route of its own, because the page IS the whole surface:
        // no staff sidebar, no portal nav and no agent panel.
        { frontend: 'public', path: 'apply', lazy: () => import('@/pages/apply/page') },
    ],
});
